module.exports = __webpack_public_path__ + "img/4.0c5f5178.png";